// 后台记录类页面共用的显示格式

const pad = (value: number) => String(value).padStart(2, '0');

/** 统一显示为“2026-10-06 16:02”（按浏览器所在时区），无效时间显示“—”。 */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** 把浏览器原始信息翻译成“iPhone · 微信”这样的说法；认不出来时显示“未知设备”。 */
export function describeUserAgent(
  userAgent: string | null | undefined,
): string {
  const ua = userAgent || '';
  if (!ua.trim()) return '未知设备';
  const device = /iPad/i.test(ua)
    ? 'iPad'
    : /iPhone|iPod/i.test(ua)
      ? 'iPhone'
      : /HarmonyOS/i.test(ua)
        ? '鸿蒙'
        : /Android/i.test(ua)
          ? 'Android'
          : /Windows/i.test(ua)
            ? 'Windows'
            : /Macintosh|Mac OS X/i.test(ua)
              ? 'Mac'
              : /Linux/i.test(ua)
                ? 'Linux'
                : '';
  const browser = /MicroMessenger/i.test(ua)
    ? '微信'
    : /QQ\//i.test(ua)
      ? 'QQ'
      : /Edg\//i.test(ua)
        ? 'Edge'
        : /OPR\/|Opera/i.test(ua)
          ? 'Opera'
          : /Firefox\//i.test(ua)
            ? 'Firefox'
            : /Chrome\/|CriOS\//i.test(ua)
              ? 'Chrome'
              : /Safari\//i.test(ua)
                ? 'Safari'
                : '';
  const parts = [device, browser].filter(Boolean);
  return parts.length ? parts.join(' · ') : '未知设备';
}
